class DamageType {
    
    static NORMAL   = "NORMAL"
    static COLD     = "COLD"
    static DEATH    = "DEATH"
    static FIRE     = "FIRE"
    static SHOCK    = "SHOCK"
    static SPIRIT   = "SPIRIT"
    static TOXIC    = "TOXIC"

    static ALL = [DamageType.NORMAL, DamageType.COLD, DamageType.DEATH, DamageType.FIRE, DamageType.SHOCK, DamageType.SPIRIT, DamageType.TOXIC]
}

export default DamageType